import React, { FunctionComponent } from 'react';
import { Box, createStyles, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';
import OnboardingTutorial from 'components/OnboardingTutorial';
import { getHelpSlides } from './Slides';
import HelpDescription from './HelpDescription';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            overflowY: 'auto',
            textAlign: 'center'
        },
        onboardingContainer: {
            height: '100%'
        }
    })
);

export const HelpSupport: FunctionComponent = () => {
    const classes = useStyles();

    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    const helpSlides = getHelpSlides(<HelpDescription />, isMobile);

    const onboardingPageParams = {
        title: 'Help & Support',
        imageWidth: 300,
        imageHeight: 500
    };

    return (
        <>
            <Box className={classes.root}>
                <Box className={classes.onboardingContainer}>
                    <OnboardingTutorial
                        id="help_support_onboarding"
                        titlePage={onboardingPageParams.title}
                        imageWidth={onboardingPageParams.imageWidth}
                        imageHeight={onboardingPageParams.imageHeight}
                        slides={helpSlides}
                    />
                </Box>
            </Box>
        </>
    );
};

export default HelpSupport;
